import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function CookiesPolicy() {
  return (
    <div className="min-h-screen bg-white">
      <div className="bg-black text-white py-10 px-6">
        <div className="container mx-auto max-w-4xl">
          <Link to="/" className="text-gray-300 hover:text-white text-sm inline-flex items-center gap-2 mb-4">
            <ArrowLeft className="w-4 h-4" /> Volver
          </Link>
          <h1 className="text-4xl md:text-5xl font-bold" style={{ fontFamily: 'Playfair Display' }}>
            Política de Cookies
          </h1>
          <p className="text-gray-400 mt-2 text-sm">Última actualización: 27 de abril de 2026</p>
        </div>
      </div>

      <article className="container mx-auto max-w-3xl px-6 py-12 text-gray-800 leading-relaxed space-y-8" data-testid="cookies-article">
        <section>
          <h2 className="text-2xl font-bold">1. ¿Qué son las cookies?</h2>
          <p className="mt-2">
            Las cookies son pequeños archivos que se descargan en tu navegador al visitar
            un sitio web. Permiten recordar información sobre tu navegación para mejorar tu
            experiencia y analizar el uso del sitio.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold">2. Cookies utilizadas en este sitio</h2>
          <div className="overflow-x-auto mt-4">
            <table className="w-full border-collapse text-sm">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 p-2 text-left">Tipo</th>
                  <th className="border border-gray-300 p-2 text-left">Finalidad</th>
                  <th className="border border-gray-300 p-2 text-left">Duración</th>
                  <th className="border border-gray-300 p-2 text-left">Base</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 p-2">Técnicas (necesarias)</td>
                  <td className="border border-gray-300 p-2">Sesión de usuario, carrito, idioma, preferencia de cookies.</td>
                  <td className="border border-gray-300 p-2">Sesión / 1 año</td>
                  <td className="border border-gray-300 p-2">Exentas de consentimiento (art. 22 LSSI)</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">Analíticas (Google Analytics)</td>
                  <td className="border border-gray-300 p-2">Medir el uso del sitio de forma agregada y anónima.</td>
                  <td className="border border-gray-300 p-2">Hasta 24 meses</td>
                  <td className="border border-gray-300 p-2">Consentimiento</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">De terceros</td>
                  <td className="border border-gray-300 p-2">Stripe (pago), YouTube (vídeos incrustados), Cloudinary (imágenes).</td>
                  <td className="border border-gray-300 p-2">Según proveedor</td>
                  <td className="border border-gray-300 p-2">Exentas / Consentimiento</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-bold">3. Cómo gestionar las cookies</h2>
          <p className="mt-2">
            Puedes aceptar, rechazar o configurar el uso de cookies desde el banner que
            aparece al entrar al sitio. También puedes desactivarlas o eliminarlas en
            cualquier momento desde la configuración de tu navegador:
          </p>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>
              <a className="text-black underline" href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">
                Google Chrome
              </a>
            </li>
            <li>
              <a className="text-black underline" href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" rel="noopener noreferrer">
                Mozilla Firefox
              </a>
            </li>
            <li>
              <a className="text-black underline" href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">
                Safari
              </a>
            </li>
            <li>
              <a className="text-black underline" href="https://support.microsoft.com/es-es/windows/eliminar-y-administrar-cookies-168dab11-0753-043d-7c16-ede5947fc64d" target="_blank" rel="noopener noreferrer">
                Microsoft Edge
              </a>
            </li>
          </ul>
          <p className="mt-3 text-sm text-gray-600">
            La desactivación de cookies técnicas puede afectar al correcto funcionamiento
            del sitio.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold">4. Más información</h2>
          <p className="mt-2">
            Consulta nuestra{' '}
            <Link to="/privacidad" className="text-black underline">Política de Privacidad</Link>
            {' '}y nuestras{' '}
            <Link to="/condiciones" className="text-black underline">Condiciones Generales de Venta</Link>.
          </p>
        </section>
      </article>
    </div>
  );
}
